import {
  EMAIL,
  ZIPCODE,
  PASSWORD,
  WEBSITE,
  PHONENUMBER,
  COUPON
} from './regExp'
export default {
  validatePassword(password, passwordConfirm) {
    // 找回密码时验证输入的密码
    var res = {
      error: false,
      msg: ''
    }
    var valiPass = function (_pass) {
      if (!_pass) {
        return '密码不能为空！'
      } else if (_pass.length < 6) {
        return '密码太短，请输入6-20位字母或数字密码'
      } else if (_pass.length > 20) {
        return '密码太长，请输入6-20位字母或数字密码'
      } else if (!PASSWORD.test(_pass)) {
        return '请输入6-20位字母或数字密码'
      }
    }
    res.msg = valiPass(password)
    if (!res.msg && (typeof passwordConfirm != 'undefined') && password != passwordConfirm) {
      res.msg = '两次输入的密码不一致，请重新输入'
    }
    if (res.msg) {
      res.error = true
    }
    return res
  },
  validateEmail(email = '') {
    var res = {
      error: false,
      msg: ''
    }
    if (!email) {
      res.msg = '请输入邮箱'
    }
    if (!EMAIL.test(email)) {
      res.msg = '请输入正确格式的邮箱'
    }
    if (res.msg) {
      res.error = true
    }
    return res
  },
  validateZipCode(zipCode = '') {
    var check = ZIPCODE.test(zipCode)
    var res = {
      error: false,
      msg: ''
    }
    if (!check) {
      res.error = true
      res.msg = 'zipcode为1-6位数字组成'
    }
    return res
  },
  validatePhoneNumber(phone = '') {
    var res = {
      error: false,
      msg: ''
    }
    if (!phone) {
      res = {
        error: true,
        msg: '电话不能为空'
      }
    } else if (PHONENUMBER.test(res)) {
      res = {
        error: true,
        msg: '电话格式不正确'
      }
    }
    return res
  },
  validateCoupon(coupon) {
    var res = {
      error: false,
      msg: ''
    }
    if (!COUPON.test(coupon)) {
      res = {
        error: true,
        msg: '请输入正确的代金券密码'
      }
    }
    return res;
  },
  validateUserName(userName) {
    var res = {
      error: false,
      msg: ''
    }
    if (!userName) {
      res.error = true;
      res.msg = '请输入用户名';
      return res;
    }
    if (!/[a-zA-Z]+/.test(userName)) {
      res.error = true;
      res.msg = '用户名需含有字母';
      return res;
    }
    if (userName.length > 20) {
      res.error = true;
      res.msg = '用户名不能超过20位字符';
      return res;
    }
    if (!/^[a-zA-Z0-9]*$/.test(userName)) {
      res.error = true;
      res.msg = '用户名只能包含字母和数字';
      return res;
    }
    return res;
  }
}



// WEBPACK FOOTER //
// ./src/utils/validateUtils.js